import { LocationType } from '@talon/web/lib/api';
import { Box, DateInput, Text } from 'grommet';
import { useEffect } from 'react';
import { fromDateInputChange } from '../../../../utils/dateOnly';
import { IAddress } from '../../../../utils/decodeGoogle';
import { Location } from '../../project-home';
import { WizardSegmentedControl } from '../WizardSegmentedControl';

interface IShootTabProps {
  geography?: string;
  union?: string;
  firstSessionDate?: string;
  place?: IAddress;
  locationType?: LocationType;
  setShoot: (value: string) => void;
  setUnion: (value: string) => void;
  setFirstSessionDate: (value: string) => void;
  setPlace: (place: IAddress | undefined) => void;
  setLocationType: (value?: LocationType) => void;
}

export const ShootTab = ({ geography, union, firstSessionDate, place, locationType, setShoot,
  setUnion, setFirstSessionDate, setPlace, setLocationType }: IShootTabProps) => {
  useEffect(() => {
    if (geography === 'offshore') {
      setUnion('nonunion');
      setPlace(undefined);
      setLocationType(undefined);
    }
  }, [geography]);
  return <Box pad="medium" gap="medium">
    <Box gap="small">
      <Text size="14px" weight={600} color="#222">Where is the shoot?</Text>
      <WizardSegmentedControl name="geography" options={[
        { label: 'USA', value: 'usa' }, { label: 'Offshore', value: 'offshore' },
      ]} value={geography} onChange={setShoot} />
      {geography === 'usa' && <Box gap="xsmall">
        <Location id="new" place={place} updatePlace={setPlace} showMap={false} />
        <Text size="12px" color="#777">Leave blank if you don't know yet.</Text>
      </Box>}
    </Box>
    <Box gap="small">
      <Text size="14px" weight={600} color="#222">First session date</Text>
      <Box width="220px">
        <DateInput id="first-session-date" aria-label="First session date" format="mm/dd/yyyy" value={firstSessionDate}
          calendarProps={{ size: 'small' }}
          onChange={({ value }) => setFirstSessionDate(fromDateInputChange(value))} />
      </Box>
    </Box>
    <Box gap="small">
      <Text size="14px" weight={600} color="#222">Talent travel</Text>
      <WizardSegmentedControl name="overnight" options={[
        { label: 'Return to the reporting site each day', value: LocationType.Nearby },
        { label: 'Stay overnight', value: LocationType.Distant },
      ]} value={locationType} onChange={setLocationType} />
    </Box>
    <Box gap="small">
      <Text size="14px" weight={600} color="#222">Union</Text>
      <WizardSegmentedControl name="union" options={[
        { label: 'Union', value: 'union', disabled: geography === 'offshore' },
        { label: 'Non-union', value: 'nonunion' },
      ]} value={union} onChange={setUnion} />
      {geography === 'offshore' && <Text size="12px" color="#555">Offshore shoots are non-union.</Text>}
    </Box>
  </Box>;
};
